import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import PageSection from '~/src/features/domru-tv/packages/components/PageSection';
import PromoBannersSection from '~/src/features/index/Banners/PromoBannersSection';

export const HeadSection = styled(PageSection)`
    @media (max-width: ${wideBreakpoints.mobile}) {
        row-gap: 24px;
    }
`;

export const PageTitle = styled.h1`
    ${FONTS.H2};
    margin: 0;

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.H3};
    }
`;

export const SPromoBannersSection = styled(PromoBannersSection)`
    margin-bottom: 0;

    & > div > div {
        margin-bottom: 0;

        & p:first-child {
            @media (max-width: ${wideBreakpoints.tablet}) {
                ${FONTS.H3};
            }
            @media (max-width: ${wideBreakpoints.mobile}) {
                ${FONTS.H4};
            }
        }
    }
`;
